"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFetchHook = exports.createResourceLoadingHook = void 0;
var react_1 = require("react");
var data_1 = require("./data");
var react_dependency_hooks_1 = require("react-dependency-hooks");
var defaultDependenciesInfo = react_dependency_hooks_1.createDependenciesInfoHook();
exports.createResourceLoadingHook = function (_a) {
    var resourceKey = _a.resourceKey, _b = _a.dependenciesInfoHook, useDependenciesInfo = _b === void 0 ? defaultDependenciesInfo : _b, defaultIsIdentificationKnownFn = _a.defaultIsIdentificationKnownFn, _c = _a.defaultForcefullyFetchFn, defaultForcefullyFetchFn = _c === void 0 ? defaultProvidedForcefullyFetchFn : _c, finalTransformationFn = _a.finalTransformationFn, fetchTransformer = _a.fetchTransformer;
    var useResourceLoading = (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _a = decipherUseResourceLoadingArgs(args), resource = _a.resource, forcefullyFetch = _a.forcefullyFetch, fetch = _a.fetch, passedIsIdentificationKnown = _a.isIdentificationKnown, dependencies = _a.dependencies;
        var _b = react_1.useState(null), error = _b[0], setError = _b[1];
        var forceUpdate = useForceUpdate();
        var resourceRef = react_1.useRef(resource);
        resourceRef.current = resource;
        var errorRef = react_1.useRef(error);
        errorRef.current = error;
        var fetchRef = react_1.useRef();
        var isFirstCall = !fetchRef.current;
        fetchRef.current = fetch;
        var isMountedRef = useMountInfo();
        var isMounted = isMountedRef.current;
        var depsInfo = useDependenciesInfo.apply(void 0, dependencies);
        var finalForcefullyFetch = forcefullyFetch === undefined
            ? defaultForcefullyFetchFn
                ? defaultForcefullyFetchFn(resource, {
                    isFirstCall: isFirstCall,
                    isMounted: isMounted,
                })
                : false
            : forcefullyFetch;
        var forcefullyFetchVersion = usePivotVersion(finalForcefullyFetch, true);
        if (depsInfo.getStableVersion() === 0 && forcefullyFetchVersion === 0) {
            depsInfo.setAsStable();
        }
        var getResource = function () {
            if (errorRef.current !== null)
                setError(null);
            var version = depsInfo.getVersion();
            var currentState = {
                shouldBeCancelled: function () {
                    return !isMountedRef.current || !depsInfo.isLastVersion(version);
                },
                getLastDependencies: function () { return depsInfo.getLastDependencies(); },
            };
            var fetchFn = fetchTransformer
                ? fetchTransformer(fetchRef.current)
                : fetchRef.current;
            var promise = fetchFn(currentState);
            if (!promise) {
                depsInfo.setAsStable(version);
                forceUpdate();
                return;
            }
            promise
                .then(function () {
                if (currentState.shouldBeCancelled()) {
                    return;
                }
                depsInfo.setAsStable(version);
                forceUpdate();
            })
                .catch(function (e) {
                if (currentState.shouldBeCancelled()) {
                    return;
                }
                depsInfo.setAsStable(version);
                setError(e);
                forceUpdate();
            });
        };
        var getResourceRef = react_1.useRef(getResource);
        getResourceRef.current = getResource;
        var currentVersion = depsInfo.getVersion();
        var isIdentificationKnown = passedIsIdentificationKnown === undefined
            ? defaultIsIdentificationKnownFn
                ? defaultIsIdentificationKnownFn(dependencies)
                : true
            : passedIsIdentificationKnown;
        react_1.useEffect(function () {
            isMountedRef.current = true;
            if (!isIdentificationKnown)
                return;
            if (!depsInfo.isStableVersion()) {
                getResourceRef.current();
            }
            else {
                depsInfo.unsafelyIncrementVersion();
                forceUpdate();
            }
        }, [currentVersion, isIdentificationKnown, forcefullyFetchVersion]);
        var fetched = depsInfo.isStableVersion();
        return react_1.useMemo(function () {
            var _a;
            var isSuccessfullyLoaded = fetched && !error;
            var finalError = fetched ? error : null;
            var finalResource = (isSuccessfullyLoaded
                ? resourceKey
                    ? (_a = {}, _a[resourceKey] = resource, _a) : resource
                : null);
            var resourceDoc = data_1.getResourceLoadingInfo({
                resource: finalResource,
                error: finalError,
                loadAgain: function () {
                    depsInfo.unsafelyIncrementVersion();
                    forceUpdate();
                },
                isIdentificationKnown: isIdentificationKnown,
            });
            return finalTransformationFn
                ? finalTransformationFn(resourceDoc)
                : resourceDoc;
        }, [resource, fetched, isIdentificationKnown, error]);
    });
    return useResourceLoading;
};
exports.createFetchHook = function (_a) {
    var resourceKey = _a.resourceKey, _b = _a.dependenciesInfoHook, dependenciesInfoHook = _b === void 0 ? defaultDependenciesInfo : _b, defaultIsIdentificationKnownFn = _a.defaultIsIdentificationKnownFn, setResourceKey = _a.dangerouslySetResourceKey, finalTransformationFn = _a.finalTransformationFn, fetchTransformer = _a.fetchTransformer;
    var useResourceLoading = exports.createResourceLoadingHook({
        resourceKey: setResourceKey ? null : resourceKey,
        dependenciesInfoHook: dependenciesInfoHook,
        defaultIsIdentificationKnownFn: defaultIsIdentificationKnownFn,
        defaultForcefullyFetchFn: function () { return true; },
        finalTransformationFn: finalTransformationFn,
        fetchTransformer: fetchTransformer,
    });
    var useFetch = function (arg) {
        var restArgs = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            restArgs[_i - 1] = arguments[_i];
        }
        var _a = react_1.useState(undefined), rawResource = _a[0], setRawResource = _a[1];
        var fetchResource;
        var rest = undefined;
        if (typeof arg === "function") {
            fetchResource = arg;
        }
        else {
            (fetchResource = arg.fetchResource, arg, rest = __rest(arg, ["fetchResource"]));
        }
        var resource = react_1.useMemo(function () {
            var _a, _b;
            if (!setResourceKey)
                return rawResource;
            if (resourceKey === null) {
                return __assign((_a = {}, _a[setResourceKey] = setRawResource, _a), rawResource);
            }
            return _b = {},
                _b[setResourceKey] = setRawResource,
                _b[resourceKey] = rawResource,
                _b;
        }, [rawResource]);
        return useResourceLoading.apply(void 0, __spreadArrays([__assign({ resource: resource, fetch: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return fetchResource.apply(void 0, args).then(function (res) {
                        if (!args[0].shouldBeCancelled()) {
                            setRawResource(res);
                        }
                    });
                } }, rest)], restArgs));
    };
    return useFetch;
};
var useMountInfo = function () {
    var isMountedRef = react_1.useRef(false);
    react_1.useEffect(function () {
        isMountedRef.current = true;
        return function () {
            isMountedRef.current = false;
        };
    }, []);
    return isMountedRef;
};
var useForceUpdate = function () {
    var _a = react_1.useReducer(function (x) { return x + 1; }, 0), forceUpdate = _a[1];
    return forceUpdate;
};
var EMPTY_STR = "G9#rA.U.'6?9[`U3.A8yXq*8z@";
var usePivotVersion = function (value, pivotValue) {
    var version = react_1.useRef(0);
    var oldValue = react_1.useRef(EMPTY_STR);
    if (value === pivotValue && oldValue.current !== value) {
        version.current++;
    }
    oldValue.current = value;
    return version.current;
};
var defaultProvidedForcefullyFetchFn = function (resource) {
    return resource === null || resource === undefined;
};
var decipherUseResourceLoadingArgs = function (args) {
    var resource;
    var forcefullyFetch = undefined;
    var fetch;
    var isIdentificationKnown = undefined;
    if (typeof args[1] === "function") {
        resource = args[0];
        fetch = args[1];
        if (args.length === 4) {
            isIdentificationKnown = !!args[2];
        }
    }
    else {
        resource = args[0].resource;
        fetch = args[0].fetch;
        forcefullyFetch = args[0].forcefullyFetch;
        if (args.length === 3) {
            isIdentificationKnown = !!args[1];
        }
    }
    var dependencies = args[args.length - 1];
    return {
        resource: resource,
        dependencies: dependencies,
        fetch: fetch,
        forcefullyFetch: forcefullyFetch,
        isIdentificationKnown: isIdentificationKnown,
    };
};
